import type { Audit } from "@/services/api/guardiansv2/types";

export interface AuditConversationScope {
  missionId: string | null;
  taskId: string | null;
}

/** Resolve mission/task scope for opening the conversation view from an audit. */
export function auditConversationScope(audit: Audit): AuditConversationScope {
  const missionId =
    audit.scope.mission_id ?? (audit.subject.type === "mission" ? audit.subject.id : null);
  const taskId =
    audit.scope.task_id ?? (audit.subject.type === "task" ? audit.subject.id : null);
  return { missionId, taskId };
}
